import http from './http'
import { getToken } from './auth'

const base = 'globalErrors'

export async function submitError(error) {

    return await http.post(`${base}`, error, {
        headers: {
            'Content-Type': 'application/json',
            'x-auth-token': getToken()
        }
    })
}